import { render, staticRenderFns } from "./inquiry-details.html?vue&type=template&id=30e628e2&scoped=true&"
import script from "./inquiry-details.vue?vue&type=script&lang=ts&"
export * from "./inquiry-details.vue?vue&type=script&lang=ts&"
import style0 from "./inquiry-details.scss?vue&type=style&index=0&id=30e628e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e628e2",
  null
  
)

export default component.exports